import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42921124"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-bottom":"env(safe-area-inset-bottom)"} }
const _hoisted_2 = { class: "icon_box" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabbar, {
      fixed: "",
      route: "",
      "z-index": "99",
      modelValue: $setup.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
      onChange: $setup.onChange,
      "active-color": $setup.TabColorSel,
      "inactive-color": $setup.TabColor
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.data, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_tabbar_item, {
            to: item.to,
            badge: item.redNum,
            max: "99",
            key: index,
            iconData: item.icon
          }, {
            icon: _withCtx((props) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: props.active ? item.icon.active : item.icon.inactive,
                  style: _normalizeStyle({ height: item.icon.height || '20px' })
                }, null, 12 /* STYLE, PROPS */, _hoisted_3)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "badge", "iconData"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "active-color"])
  ]))
}